const RepeatedRepairPoints = [
  [30.0, 1],
  [43.0, 1],
  [0.0, 2],
  [50.0, 2],
  [0.0, 3],
  [28.0, 3],
  [0.0, 4],
  [5.0, 4],
  [21.0, 4],
  [28.0, 4],
  [54.0, 4],
  [68.0, 4],
  [38.0, 5],
  [56.0, 5],
  [58.0, 5],
  [71.0, 5],
  [0.0, 6],
  [21.0, 6],
  [36.0, 6],
  [50.0, 6],
  [67.0, 6],
  [0.0, 7],
  [20.0, 7],
  [56.0, 7],
  [0.0, 8],
  [10.0, 8],
  [19.0, 8],
  [41.0, 8],
  [73.0, 8],
  [90.0, 8],
  [0.0, 9],
  [17.0, 10],
  [23.0, 11],
  [60.0, 11],
  [0.0, 12],
  [49.0, 12],
  [0.0, 13],
  [25.0, 13],
  [38.0, 13],
  [0.0, 14],
  [14.0, 14],
  [0.0, 15],
  [42.0, 15],
  [12.0, 16],
  [19.0, 16],
  [36.0, 16],
  [20.0, 17],
  [33.0, 17],
  [0.0, 18],
  [20.0, 18],
  [62.0, 18],
  [68.0, 18],
  [4.0, 19],
  [47.0, 19],
  [0.0, 20],
  [41.0, 20],
  [58.0, 20],
  [0.0, 21],
  [7.0, 21],
  [26.0, 21],
  [71.0, 21],
  [13.0, 22],
  [23.0, 22],
  [0.0, 23],
  [23.0, 23],
  [59.0, 23],
  [83.0, 23],
  [0.0, 24],
  [2.0, 25],
  [11.0, 25],
  [56.0, 25],
  [17.0, 26],
  [25.0, 26],
  [39.0, 26],
  [10.0, 27],
  [8.0, 28],
  [28.0, 29],
  [4.0, 30],
  [8.0, 30],
  [16.0, 30],
  [13.0, 31],
  [18.0, 31],
  [22.0, 31],
  [0.0, 32],
  [48.0, 32],
  [78.0, 32],
  [83.0, 32],
  [11.0, 33],
  [35.0, 33],
  [74.0, 33],
  [0.0, 34],
  [6.0, 34],
  [0.0, 35],
  [16.0, 35],
  [29.0, 36],
  [34.0, 36],
  [0.0, 37],
  [10.0, 37],
  [22.0, 37],
  [0.0, 38],
  [41.0, 38],
  [28.0, 39],
  [68.0, 39],
  [70.0, 39],
  [0.0, 40],
  [26.0, 40],
  [36.0, 40],
  [57.0, 40],
  [0.0, 41],
  [0.0, 42],
  [0.0, 43],
  [36.0, 43],
  [78.0, 43],
  [0.0, 44],
  [2.0, 44],
  [4.0, 44],
  [15.0, 44],
  [31.0, 44],
  [42.0, 44],
  [49.0, 44],
  [51.0, 44],
  [2.0, 45],
  [0.0, 46],
  [19.0, 46],
  [54.0, 46],
  [78.0, 46],
  [7.0, 47],
  [26.0, 47],
  [40.0, 47],
  [28.0, 48],
  [41.0, 48],
  [50.0, 48],
  [28.0, 49],
  [0.0, 50],
  [43.0, 50],
  [64.0, 50],
  [78.0, 50],
  [12.0, 51],
  [25.0, 51],
  [69.0, 51],
  [2.0, 52],
  [0.0, 53],
  [7.0, 54],
  [24.0, 54],
  [75.0, 54],
  [36.0, 55],
  [52.0, 55],
  [72.0, 55],
  [46.0, 56],
  [52.0, 56],
  [0.0, 57],
  [39.0, 58],
  [45.0, 58],
  [0.0, 59],
  [20.0, 59],
  [0.0, 60],
  [31.0, 61],
  [32.0, 62],
  [0.0, 63],
  [35.0, 63],
  [37.0, 63],
  [12.0, 64],
  [20.0, 64],
  [33.0, 64],
  [13.0, 65],
  [4.0, 66],
  [30.0, 66],
  [42.0, 66],
  [6.0, 67],
  [0.0, 68],
  [42.0, 68],
  [0.0, 69],
  [53.0, 69],
  [74.0, 69],
  [80.0, 69],
  [87.0, 69],
  [0.0, 70],
  [0.0, 71],
  [19.0, 71],
  [21.0, 71],
  [33.0, 71],
  [55.0, 71],
  [0.0, 72],
  [27.0, 72],
  [31.0, 72],
  [16.0, 73],
  [0.0, 74],
  [21.0, 74],
  [36.0, 74],
  [0.0, 75],
  [7.0, 75],
  [22.0, 75],
  [35.0, 75],
];

export default RepeatedRepairPoints;
